
import { Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class AccordionItem extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() color!: string;
  @Prop() isActive?: boolean;
  @Prop() wasReviewed?: boolean;
  public $refs!: {
    content: HTMLElement;
  };
  public completed: boolean = false

  closed: boolean = true;
  showCompletion!: boolean;
  closedTimeout : any;
  innerVideo: any;

  mounted(){
    if(this.isActive) this.toggle();
    if(this.wasReviewed) {
      this.completed = true;
      this.showCompletion = true;
    }

    let videoWrapper = this.$children.find(child => { return child.$options.name === 'VideoWrapper'; });
    setTimeout(()=>{
      if(videoWrapper)
        this.onPlayerReady((videoWrapper.$refs as any).video.player);
        
    },100);
  }

  async toggle(){
    this.closed = !this.closed;
    this.completed = true;
    this.$emit('toggle', {isOpened: true, id: (this as any)._uid});
    if(!this.innerVideo)
      return;
    if(this.closed)
      this.innerVideo.pause();
    else 
      this.innerVideo.play();
    
  }

  get contentHeight(){
    return this.$refs.content.scrollHeight + 'px';
  }
  
  public close(){
    this.closed = true;
    if(this.innerVideo)
      this.innerVideo.pause();
  }

  onPlayerReady(video:any){
    this.innerVideo = video;
    video.on('play', ()=>{
      if(this.closed)
        video.pause();
      
    });
    video.pause();
  }

  titleToId(title:string){
    return title.replace(/\s|\?|\!|\./g, '');
  }

  checkVideo(){
    return !!document.getElementById('VideoPlayer');
  }
  get id(){
    return `${this.titleToId(this.title)}-${(this as any)._uid}`;
  }
}
